import React, { FC } from 'react';
import { IHandledDocument, ISearchProfile } from '../../types';
import { useDocumentsByProfiles } from '../../hooks';
import SearchProfileGroup from './SearchProfileGroup';

export interface ISearchResultsByProfilesProps {
  documents: IHandledDocument[];
  searchProfiles: ISearchProfile[];
}

export const SearchResultsByProfiles: FC<ISearchResultsByProfilesProps> = props => {
  const { documents, searchProfiles } = props;
  const documentsByProfiles = useDocumentsByProfiles(documents, searchProfiles);
  return (
    <>
      {documentsByProfiles.map(profileAndDocuments => {
        return (
          profileAndDocuments.documents.length > 0 && (
            <SearchProfileGroup
              key={profileAndDocuments.searchProfile.id}
              documents={profileAndDocuments.documents}
              searchProfile={profileAndDocuments.searchProfile}
            />
          )
        );
      })}
    </>
  );
};

export default SearchResultsByProfiles;
